module.exports = __webpack_public_path__ + "img/shipping_booking.b7abbc2b.svg";